import React from 'react';
import { RefreshCw, AlertTriangle } from 'lucide-react';

const SYNCED_TOOLTIP =
  'Synced means commit and pull request data from GitHub has been imported for this repository. Metrics update after each sync.';

// Keep in sync with NOTIFY_AT_FAILURE_COUNT in backend/src/services/notifications/repoSyncFailureNotificationService.ts
const SYNC_FAILING_THRESHOLD = 3;

export default function RepositorySyncIndicator({ repo }: any) {
  if (repo?.isSyncing) {
    return (
      <div className="mt-0.5 inline-flex items-center gap-1.5 text-blue-400">
        <RefreshCw className="w-3.5 h-3.5 animate-spin flex-shrink-0" aria-hidden />
        Syncing…
      </div>
    );
  }

  const failures = repo?.consecutiveSyncFailures ?? 0;
  if (failures >= SYNC_FAILING_THRESHOLD) {
    const lastAttempt = repo?.lastSyncAttemptAt ? new Date(repo.lastSyncAttemptAt).toLocaleString() : null;
    const title = [
      `Sync failing: ${failures} consecutive attempts have failed.`,
      repo?.lastSyncError ? `Last error: ${repo.lastSyncError}` : null,
      lastAttempt ? `Last attempt: ${lastAttempt}` : null,
    ]
      .filter(Boolean)
      .join(' ');
    return (
      <div
        className="mt-0.5 inline-flex items-center gap-1.5 rounded-md border-amber-700/50 bg-amber-950/35 px-2 py-1 text-amber-100 font-medium"
        title={title}
      >
        <AlertTriangle className="h-3.5 w-3.5 shrink-0" aria-hidden />
        Sync failing
      </div>
    );
  }

  if (repo?.lastSyncedAt) {
    const label = new Date(repo.lastSyncedAt).toLocaleString();
    return (
      <div
        className="mt-0.5 inline-flex items-center gap-1 text-green-400"
        title={`${SYNCED_TOOLTIP} Last sync: ${label}`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-green-500" aria-hidden />
        Synced
      </div>
    );
  }
  return (
    <div className="mt-0.5 text-xs text-slate-400" title={SYNCED_TOOLTIP}>
      Not synced yet
    </div>
  );
}
